var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.label || _vm.$t('common.type'),"items":_vm.fieldPbehaviorTypes,"loading":_vm.fieldPbehaviorTypesPending,"multiple":_vm.multiple,"chips":_vm.chips,"deletable-chips":_vm.chips,"small-chips":_vm.chips,"item-text":"name","item-value":"_id","disabled":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }